import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { useEffect } from "react";
import "@/App.css";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import { AdsenseInjector } from "@/components/AdsenseInjector";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Directory from "@/pages/Directory";
import ServiceDetail from "@/pages/ServiceDetail";
import Showcase from "@/pages/Showcase";
import { BlogList, BlogPost } from "@/pages/Blog";
import Contact from "@/pages/Contact";
import About from "@/pages/About";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Lotto from "@/pages/Lotto";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function MainChrome({ children }) {
  const { pathname } = useLocation();
  const inLotto = pathname === "/lotto" || pathname.startsWith("/lotto/");
  return (
    <>
      {!inLotto && <Header />}
      {children}
      {!inLotto && <Footer />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <ScrollTop />
          <AdsenseInjector />
          <MainChrome>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/directory" element={<Directory />} />
              <Route path="/service/:slug" element={<ServiceDetail />} />
              <Route path="/showcase" element={<Showcase />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/about" element={<About />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/lotto" element={<Lotto />} />
            </Routes>
          </MainChrome>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
